import React, {useEffect, useRef, useState} from "react";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import "./style.scss";
import {useDispatch} from "react-redux";
import {storeVideo} from "../../../slices/video";
import {ContentType} from "../../../db/models/content";

interface Props {
    video: ContentType;
    height: string;
    width: string;
}

export const VideoFrame: React.FC<Props> = ({video, width, height}) => {
    const videoRef = useRef<any>(null);
    const dispatch = useDispatch();

    const handleFullScreen = (event) => {
        event.stopPropagation();
        dispatch(storeVideo({video}));
    };

    useEffect(() => {
        videoRef.current.load();
    }, [video]);

    return (
        <div className="videoFrame" onClick={(e) => handleFullScreen(e)}>
            <button>
                <PlayCircleFilledIcon/>
            </button>
            <video
                width={width}
                height={height}
                controls={false}
                ref={videoRef}
                controlsList="nodownload"
                // onClick={(e) => handlePlayPause(e)}
            >
                <source src={video?.sources?.[0]}/>
                Your browser does not support the video tag.
            </video>
        </div>
    );
};
